import { PropsWithChildren } from 'react';

import { Dialog } from '@verantos-dev/shared-components';

export const AutoSubmitDialogWrapper = ({
  id,
  children,
  onClose,
}: PropsWithChildren<{ id: string; onClose: () => void }>) => {
  return (
    <Dialog
      id={id}
      open
      PaperProps={{
        sx: { width: '600px', maxHeight: '80%', margin: 0 },
      }}
      fullWidth
      maxWidth="lg"
      onClose={onClose}
    >
      {children}
    </Dialog>
  );
};
